import { slot } from "@fluentui/react-components";
import type {
  RibbonIconPreviewGalleryProps,
  RibbonIconPreviewGalleryState,
} from "./RibbonIconPreviewGallery.types";
// eslint-disable-next-line no-restricted-imports
import { AppIconPreviewGallery } from "@1js/acui-gallery-icon/lib/Next";

export const useRibbonIconPreviewGallery = (
  props: RibbonIconPreviewGalleryProps,
  ref: React.Ref<HTMLDivElement>
): RibbonIconPreviewGalleryState => {
  const root = slot.always(
    { ...props, ref },
    {
      defaultProps: {
        ...props,
        dataAutomationType: "RibbonIconPreviewGallery",
        persistMenu: true,
        ref,
      },

      elementType: AppIconPreviewGallery,
    }
  );

  return {
    ...props,
    components: {
      root: AppIconPreviewGallery,
    },
    root,
  };
};
